import { render, staticRenderFns } from "./Waitlist.vue?vue&type=template&id=3afc1e06&"
import script from "./Waitlist.vue?vue&type=script&lang=js&"
export * from "./Waitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports